import { WidgetConfig } from "@aichat/types/widget";
import { createContext, useContext } from "react";
import { defaultWidgetConfig } from "@aichat/constants/widget";

export const WebWidgetConfigContext =
  createContext<WidgetConfig>(defaultWidgetConfig);

export const useWebWidgetConfig = () => {
  const config = useContext(WebWidgetConfigContext);
  if (!config)
    throw new Error(
      "useWebWidgetConfig must be used within a WebWidgetProvider",
    );
  return config;
};
